@if (order$ | async; as order) {
  @if (!(isOrderLoading$ | async)) {
    <udx-cx-order-overview></udx-cx-order-overview>
  }
}
